import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-christmas-notification-dialog',
  templateUrl: './christmas-notification-dialog.component.html',
  styleUrls: ['./christmas-notification-dialog.component.scss']
})
export class ChristmasNotificationDialogComponent {

  constructor(public dialogRef: MatDialogRef<ChristmasNotificationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }
}
